import { fetchSizesApi } from './api'

export const SET_SIZES = 'SET_SIZES';
export const FETCHING_SIZE = 'FETCHING_SIZE';

function fetchingSize() {
  return {
    type: FETCHING_SIZE,
  };
}

function setSizes(sizes) {
  return {
    type: SET_SIZES,
    sizes: sizes
  };
}

export function fetchSizes(user_token) {
  return function (dispatch) {
    dispatch(fetchingSize())
    return fetchSizesApi(user_token)
    .then(json =>
      dispatch(setSizes(json))
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/sizes.js